/* Sunnyside ATC v8 — full drawer replace, direct checkout link */
(function () {
  'use strict';

  var FREE_SHIPPING_THRESHOLD = 8000;

  function updateMeter(cents) {
    document.querySelectorAll('.sunnyside-shipping-meter').forEach(function (m) {
      var bar = m.querySelector('.sunnyside-shipping-meter__bar');
      var msg = m.querySelector('.sunnyside-shipping-meter__msg');
      var pct = Math.min(100, Math.round((cents / FREE_SHIPPING_THRESHOLD) * 100));
      if (bar) bar.style.width = pct + '%';
      if (msg) {
        if (cents >= FREE_SHIPPING_THRESHOLD) {
          msg.textContent = '\u2600\ufe0f You unlocked free shipping!';
          msg.style.color = '#8FA882'; msg.style.fontWeight = '700';
        } else {
          var d = Math.floor((FREE_SHIPPING_THRESHOLD - cents) / 100);
          var c = (FREE_SHIPPING_THRESHOLD - cents) % 100;
          msg.textContent = 'Add $' + d + '.' + (c < 10 ? '0' : '') + c + ' more for free shipping';
          msg.style.color = ''; msg.style.fontWeight = '';
        }
      }
    });
  }

  function updateCount(count) {
    document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
      var h = el.querySelector('[aria-hidden="true"]');
      if (h) h.textContent = count;
      var v = el.querySelector('.visually-hidden');
      if (v) v.textContent = count + ' items';
      if (count > 0) el.classList.remove('hidden');
    });
  }

  /* Full replace of drawer__inner — no partial patches, no race conditions */
  function refreshDrawer(callback) {
    fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) { if (callback) callback(); return; }
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newInner = doc.querySelector('.drawer__inner');
        var oldDrawer = document.querySelector('cart-drawer');
        var oldInner = oldDrawer && oldDrawer.querySelector('.drawer__inner');
        if (newInner && oldInner) {
          oldInner.innerHTML = newInner.innerHTML;
          /* Remove empty states */
          oldDrawer.classList.remove('is-empty');
          var di = oldDrawer.querySelector('cart-drawer-items');
          if (di) di.classList.remove('is-empty');
          /* Scroll items to very top */
          if (di) di.scrollTop = 0;
        }
        if (callback) callback();
      })
      .catch(function () { if (callback) callback(); });
  }

  function openDrawer() {
    var el = document.querySelector('cart-drawer');
    if (!el) return;
    el.classList.remove('is-empty');
    if (typeof el.open === 'function') { el.open(); return; }
    el.removeAttribute('inert');
    /* Fallback: click cart icon */
    var icon = document.querySelector('#cart-icon-bubble');
    if (icon) { var a = icon.closest('a,button'); if (a) a.click(); }
  }

  function doATC(variantId, qty, properties, btn) {
    if (!variantId || variantId === '0') return;
    var origText = btn.textContent;
    btn.disabled = true; btn.style.opacity = '0.7';
    if (btn.tagName === 'BUTTON') btn.textContent = 'Adding\u2026';
    var payload = { id: parseInt(variantId, 10), quantity: parseInt(qty, 10) || 1 };
    if (properties && Object.keys(properties).length) payload.properties = properties;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Failed'); });
      return r.json();
    })
    .then(function () {
      if (btn.tagName === 'BUTTON') {
        btn.textContent = 'Added \u2713';
        btn.style.background = '#8FA882'; btn.style.color = '#F5ECD7'; btn.style.opacity = '1';
      }
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCount(cart.item_count);
          updateMeter(cart.total_price);
          refreshDrawer(function () { setTimeout(openDrawer, 80); });
        })
        .catch(function () { refreshDrawer(function () { setTimeout(openDrawer, 80); }); });
      setTimeout(function () {
        btn.disabled = false; btn.style.opacity = ''; btn.style.background = ''; btn.style.color = '';
        if (btn.tagName === 'BUTTON') btn.textContent = origText;
      }, 2500);
    })
    .catch(function (err) {
      console.error('[Sunnyside ATC]', err);
      btn.disabled = false; btn.style.opacity = '';
      if (btn.tagName === 'BUTTON') {
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = origText; }, 2000);
      }
    });
  }

  function doUpsellATC(variantId, btn) {
    if (!variantId) return;
    var origText = btn.textContent;
    btn.textContent = '\u2713'; btn.style.background = '#8FA882'; btn.style.color = '#F5ECD7'; btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        updateCount(cart.item_count); updateMeter(cart.total_price); refreshDrawer();
      }).catch(function () { refreshDrawer(); });
      setTimeout(function () { btn.textContent = origText; btn.style.background = ''; btn.style.color = ''; btn.disabled = false; }, 1800);
    })
    .catch(function () { btn.textContent = origText; btn.style.background = ''; btn.style.color = ''; btn.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    var atc = e.target.closest('[data-sunnyside-atc]');
    if (atc) {
      e.preventDefault(); e.stopPropagation();
      doATC(atc.getAttribute('data-variant-id'), atc.getAttribute('data-quantity') || '1',
        atc.getAttribute('data-pool-color') ? { 'Pool Color': atc.getAttribute('data-pool-color') } : {}, atc);
      return;
    }
    var upsell = e.target.closest('[data-sunnyside-upsell-atc]');
    if (upsell) { e.preventDefault(); e.stopPropagation(); doUpsellATC(upsell.getAttribute('data-variant-id'), upsell); }
  });

  document.addEventListener('DOMContentLoaded', function () {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      updateMeter(cart.total_price); updateCount(cart.item_count);
    }).catch(function () {});
  });

})();
